import { OSType, ScreenSizeType } from 'types/client';

export const Breakpoints = {
	tabletStart: 768,
	desktopStart: 1200
};

export const getScreenSize = (): ScreenSizeType => {
	const screenWidth = window.innerWidth;

	if (screenWidth < Breakpoints.tabletStart) {
		return 'MOBILE';
	} else if (screenWidth >= Breakpoints.desktopStart) {
		return 'DESKTOP';
	} else {
		return 'TABLET';
	}
};

export const getOS = (): OSType | null => {
	const userAgent = window.navigator.userAgent;
	const platform = window.navigator.platform;
	const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
	const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
	const iosPlatforms = ['iPhone', 'iPad', 'iPod'];

	if (macosPlatforms.indexOf(platform) !== -1) {
		if (window.navigator.maxTouchPoints > 1) {
			return 'iOS'; //iPadOS workaround
		}
		return 'MacOS';
	} else if (iosPlatforms.indexOf(platform) !== -1) {
		return 'iOS';
	} else if (windowsPlatforms.indexOf(platform) !== -1) {
		return 'Windows';
	} else if (/Android/.test(userAgent)) {
		return 'Android';
	} else if (/Linux/.test(platform)) {
		return 'Linux';
	} else {
		return null;
	}
};
export const isIphone = (): boolean => {
	const userAgent = window.navigator.userAgent;
	return userAgent.includes('iPhone') && !userAgent.includes('iPad');
};

export const isMobileOS = (): boolean => {
	const userAgent = window.navigator.userAgent;
	if (isIphone() || userAgent.includes('Android')) {
		return true;
	}

	return false;
};

export const isWebview = (): boolean => {
	const userAgent = window.navigator.userAgent;
	return userAgent.includes('Fundrise iOS WebView');
};

export const redirect = (path: string): void => {
	window.location.href = process.env.VUE_APP_BASE_PATH + path;
};

export const replaceRoute = (path: string): void => {
	const url = process.env.VUE_APP_BASE_PATH + path;
	window.location.replace(url);
};

export const openNewTab = (path: string): void => {
	window.open(path, '_blank');
};

export const isElementFullyVisible = (element: Element): boolean => {
	const domElement = element.getBoundingClientRect();
	const html = document.documentElement;
	if (
		domElement.top >= 0 &&
		domElement.left >= 0 &&
		domElement.bottom <= (window.innerHeight || html.clientHeight) &&
		domElement.right <= (window.innerWidth || html.clientWidth)
	) {
		return true;
	} else {
		return false;
	}
};
